import { render, staticRenderFns } from "./BCLogs.vue?vue&type=template&id=2813bd13&scoped=true"
import script from "./BCLogs.vue?vue&type=script&lang=js"
export * from "./BCLogs.vue?vue&type=script&lang=js"
import style0 from "./BCLogs.vue?vue&type=style&index=0&id=2813bd13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813bd13",
  null
  
)

export default component.exports